import {
  Button, Chip, Dialog, DialogActions, DialogContent,
  DialogTitle, Grid, Table,
  TableBody, TableCell, TableContainer, TableRow,
  Paper, Input
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import { SwipeableListItem } from '@sandstreamdev/react-swipeable-list';
import React from 'react';
import Highlighter from "react-highlight-words";
import { FaMedium, FaTree } from "react-icons/fa";
import { GiNewspaper } from 'react-icons/gi';
import { connect } from 'react-redux';
import GenericBulten from 'src/components/GenericBulletin';
import axios from 'src/utils/axios';
import { setMaterialQuan, setMaterialSelection, setMaterialFilterKey } from '../../store/actions';
import ComplexSwipeContent from '../ComplexSwipeContent';

const useStyles = makeStyles((theme) => ({
  tableContainerMaterial: {
    display: 'block',
    width: '100%',
    overflowX: 'auto',
    minHeight: 500,
  },
  tableMaterial: {
    display: 'block',
    width: '100%',
    overflowX: 'auto',
  },
  tableCellMaterial: {
    maxWidth: 10,
  },
  tableCell1Material: {
    paddingLeft: 0,
    paddingRight: 2,
    maxWidth: 7,
  },
  searchBMaterial: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconBMaterial: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputBMaterial: {
    flexGrow: 1
  },
  searchButtonBMaterial: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
}));

const MaterialTable = (props) => {
  const classes = useStyles();
  const [bultenOpenMaterial, setBultenOpenMaterial] = React.useState(false);
  const [bultenParamMaterial, setBultenParamMaterial] = React.useState('');
  const [muadilOpenMaterial, setMuadilOpenMaterial] = React.useState(false);
  const [muadilParamMaterial, setMuadilParamMaterial] = React.useState('');
  const [muadilTitleMaterial, setMuadilTitleMaterial] = React.useState('');



  let selectedAll = [];
  if (props.selectedDefects) {
    props.selectedDefects.forEach(d => {
      if (props.materials[d])
        selectedAll = [...selectedAll, ...props.materials[d]];
    });
  }






  const isUsedBefore = (name) => (selectedAll && selectedAll.indexOf(name) !== -1);

  const highlightMaterial = (text) => {
    return <Highlighter
      searchWords={[props.materials.filterKey]}
      autoEscape={true}
      textToHighlight={text}
    />
  }

  const malzemeGosterMaterial = (materialCode) => {
    const data = {
      MALZEME_STOK_NO: materialCode,
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    let newWindow = window.open();
    if (!newWindow) {
      alert('Popup engelleyici aktif. Lütfen bu site için popup\'lara izin verin.');
      return;
    }
    axios.post('/FileImportExport/ArtemisMalzeme', data, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        newWindow.location = fileURL;
        newWindow.document.title = materialCode;
      })
  }

  const MuadilMalzemeGosterMaterial = (txt, malzeme) => {
    setMuadilParamMaterial(txt);
    setMuadilTitleMaterial(malzeme)
    setMuadilOpenMaterial(true);
  }

  const handleBultenOpenMaterial = (param) => {
    setBultenParamMaterial(param);
    setBultenOpenMaterial(true);
  }

  const getMaterialRowMaterial = (row) => {

    if (row === undefined) {
      return "";
    }



    return (
      <SwipeableListItem dense={true}
        swipeLeft={{
          content: (
            <ComplexSwipeContent
              icon={<FaMedium size={30} />}
              label="Muadil Malzeme"
              position="right"
              css="muadil"
            />
          ), 
          action: () => MuadilMalzemeGosterMaterial(row.ActiveMuadil, row.MaterialCode)
        }}
        swipeRight={{
          content: (
            <ComplexSwipeContent
              icon={<GiNewspaper size={30} />}
              label="Malzeme Bülteni"
              position="left"
              css="bulten"
            />
          ),
          action: () => handleBultenOpenMaterial(row.MaterialCode)
        }}
        blockSwipe={props.readonly}
        key={row.MaterialCode}
      >
        <TableRow>
          <TableCell className={classes.tableCell1Material}>
            <FaTree color='#FF9800' size='1.5em' visibility={parseInt(row.HistoricalBom) === 1 ? "show" : "hidden"} />
          </TableCell>
          <TableCell className={classes.tableCellMaterial}>
            <ImageSearchIcon
              onClick={() => malzemeGosterMaterial(row.MaterialCode)}
              color="primary">
            </ImageSearchIcon>
          </TableCell>
          <TableCell scope="row">
            <Grid container spacing={0}>
              <Grid style={{ color: row.SIP_VERILEBILIR ? 'inherit' : 'red' }} item xs={12}>
                <b>{highlightMaterial(row.MaterialCode)}</b>
                {" "}
                {highlightMaterial(row?.MaterialDesc)}
                <b>
                  <Chip size="small"
                    label={row?.PriceWithWat + " ₺"}
                  />
                  <Chip size="small"
                    label={'Ref:' + row?.Ref}
                  />
                  {row.ActiveMuadil.length > 0 && <Chip color="secondary" size="small"
                    label={'M'}
                  />}
                </b>
              </Grid>
            </Grid>
          </TableCell>
        </TableRow>
      </SwipeableListItem>
    )
  }


  return (
    <>
      <Dialog
        open={bultenOpenMaterial}
        onClose={() => setBultenOpenMaterial(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          Malzemeye Ait Bültenler
        </DialogTitle>
        <DialogContent>
          <GenericBulten param={bultenParamMaterial} />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setBultenOpenMaterial(false)}
            className={classes.buttonMaterial}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen
        open={muadilOpenMaterial}
        onClose={() => setMuadilOpenMaterial(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          {muadilTitleMaterial} Malzemenin Muadilleri
        </DialogTitle>
        <DialogContent>
          <TableContainer >
            <Table size="small" aria-label="material table">
              <TableBody className={classes.tableMaterial}>
                {muadilParamMaterial.length === 0 ? 'Muadil Malzeme Bulunmuyor!...' : muadilParamMaterial.split(',').map((m, index) => {
                  let row = props.materials?.materialsTable[m];
                  return getMaterialRowMaterial(row, index);
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setMuadilOpenMaterial(false)}
            className={classes.buttonMaterial}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Paper
        className={classes.searchBMaterial}
        elevation={1}>
        <Input
          className={classes.searchInputBMaterial}
          disableUnderline
          value={props.materials.filterKey}
          onChange={(event) => props.setMaterialFilterKey(event.target.value)}
          placeholder="Malzeme kodu ya da adını giriniz..."
        />
        <SearchIcon className={classes.searchIconBMaterial} />
      </Paper>
      <br />
      <TableContainer >
        <Table size="small" aria-label="material table">
          <TableBody className={classes.tableMaterial}>
            {(props.materials.filtered) && props.materials.filtered.sort(s => isUsedBefore(s.MaterialCode) ? -1 : 1).slice(0, props.GosterimAdet).map((row, index) => {
              return getMaterialRowMaterial(row, index);
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}


const mapStateToProps = (state) => ({
  materials: state.materialReducer,
  selectedDefects: state.defectReducer.selected,
});

const mapDispatchToProps = {
  setMaterialSelection: setMaterialSelection,
  setMaterialQuan: setMaterialQuan,
  setMaterialFilterKey: setMaterialFilterKey,
};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialTable)
